import React, {useEffect, useState} from "react";
import ReactPixel from 'react-facebook-pixel';
import './style.scss';
import LogoImage from "../../../resources/images/ShipitLogo.png";
import Button from "@material-ui/core/Button";
import LockIcon from '@material-ui/icons/LockOpen';
import BackgroundParticles from "../../Components/BackgroundParticles/BackgroundParticles";
import Direction from "../../Utils/Direction/Direction";
import SendIcon from "../../Utils/Icons/SVGs/SendIcon";
import axios from "axios";
import AnimatedCheckmark from "../../Utils/Icons/SVGs/AnimatedCheckmark/AnimatedCheckmark";
import BarsGraphIcon from "../../Utils/Icons/SVGs/ValueProposition/BarsGraphIcon";
import TrackerIcon from "../../Utils/Icons/SVGs/ValueProposition/TrackerIcon";
import RouteIcon from "../../Utils/Icons/SVGs/ValueProposition/RouteIcon";


export default function Home(props) {
    const [name, setName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isSent, setIsSent] = useState(false);

    useEffect(() => {
        ReactPixel.init('329502781972619');
        ReactPixel.pageView();
    }, []);

    function goToLoginPage() {
        props.history.push('/login')
    }

    async function sendDetails() {
        if (name || phoneNumber) {
            setIsSent(true);

            await axios.post('/api/v2/leads/', {
                "name": name,
                "phoneNumber": phoneNumber
            });

            setTimeout(() => setIsSent(false), 5000);
        }
    }

    return (
        <Direction direction="rtl">
            <div className="home-page">
                <div className="login-button-container">
                    <Button variant="outlined" color="primary" className="login-button"
                            onClick={goToLoginPage}>
                        <LockIcon className="lock-icon"/>
                        התחבר
                    </Button>
                </div>
                <div className="logo-container">
                    <div className="logo">
                        <img src={LogoImage} alt="Shipit"/>
                    </div>
                </div>
                <div className="content">
                    <div className="shipit-description">
                        <h1 className="shipit-main-description">
                            <div>ניהול משלוחים</div>
                            &nbsp;
                            <div>מבוסס בינה מלאכותית</div>
                        </h1>
                    </div>
                    <div className="shipit-video-beautiful-container">
                        <div className="shipit-video">
                            <div className="second-video-after-container">
                                <div className="second-video-after"/>
                            </div>
                            <div className="first-video-after-container">
                                <div className="first-video-after"/>
                            </div>
                            <div className="shipit-video-player-container">
                                <video className="shipit-video-player" autoPlay playsInline muted loop>
                                    <source src="https://d27cdlofxrtzm0.cloudfront.net/shipittrailer.mp4"
                                            type="video/mp4"/>
                                </video>
                            </div>
                        </div>
                    </div>
                    <div className="value-proposition">
                        <div className="value-proposition-item">
                            <div className="value-proposition-icon-container">
                                <RouteIcon fontSize="70px"/>
                            </div>
                            <div className="value-proposition-description">
                                1. חישוב מסלולים אוטומטי
                            </div>
                        </div>
                        <div className="arrow-container">
                            <div className="arrow">←</div>
                        </div>
                        <div className="value-proposition-item">
                            <div className="value-proposition-icon-container">
                                <TrackerIcon fontSize="70px"/>
                            </div>
                            <div className="value-proposition-description">
                                2. מעקב אחר זמני ההגעה
                            </div>
                        </div>
                        <div className="arrow-container">
                            <div className="arrow">←</div>
                        </div>
                        <div className="value-proposition-item">
                            <div className="value-proposition-icon-container">
                                <BarsGraphIcon fontSize="70px"/>
                            </div>
                            <div className="value-proposition-description">
                                3. ניתוח נתונים והפקת תובנות
                            </div>
                        </div>
                    </div>
                    <div className="contact">
                        <div className="contact-title">
                            השאירו פרטים ונחזור אליכם
                        </div>
                        <div className="contact-form">
                            <div className="contact-form-fields">
                                <input className="text-input name-input"
                                       type="text"
                                       placeholder="איך קוראים לך?"
                                       onChange={e => setName(e.target.value)}
                                       value={name}/>
                                <input className="text-input phone-input"
                                       type="tel"
                                       pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                                       value={phoneNumber}
                                       onChange={e => setPhoneNumber(e.target.value)}
                                       placeholder="מה מספר הטלפון שלך?"/>
                            </div>
                            <div className="send-button-container">
                                <Button variant="contained" color="primary"
                                        className={"send-button" + (isSent ? " send-button-sent" : "")}
                                        onClick={sendDetails}>

                                    <div className="send-button-content">
                                        <div className="send-icon-container">
                                            <div className={"send-icon" + (isSent ? " send-icon-hidden" : "")}>
                                                <SendIcon fontSize={"35px"}/>
                                            </div>
                                            {
                                                isSent ?
                                                    <div className="send-checkmark-icon">
                                                        <AnimatedCheckmark fontSize={"35px"}/>
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>
                                        <div className="send-text-container">
                                            <div className={"send-text" + (isSent ? "" : " hidden-send-text")}>
                                                נשלח
                                            </div>
                                            <div
                                                className={"send-text absolute-send-text" + (isSent ? " hidden-send-text" : "")}>
                                                שלח
                                            </div>
                                        </div>
                                    </div>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="background-particles-container">
                    <div className="opacity-gradient"/>
                    <BackgroundParticles/>
                </div>
            </div>
        </Direction>
    );
}